<app-dashboard-layout [pageTitle]="'employees.title' | translate" [actionLabel]="'employees.layout.action.add' | translate" [hasAction]="employees.length > 0"
    (onNotificationClick)="onNotificationClicked()" (onAction)="onActionClicked()">
    <div pageContent>
        <ng-container *ngIf="employees.length > 0 || !alreadyLoaded; else emptyList">
            <ng-container *ngIf="hasNewItem; else noNews">
                <p class="bg-green-200 text-green-600 py-2 px-4 rounded-2xl border border-green-300">{{'employees.added.notification' | translate}}</p>
            </ng-container>
            <ng-template #noNews>
                <ng-container *ngIf="alreadyLoaded; else loadingList">
                    <p>{{'employees.fulllist.header' | translate}}</p>
                </ng-container>
            </ng-template>
            <br class="colors-background h-8">
            <app-full-employees-list [employees]="employees" [isLoading]="!alreadyLoaded" (onUpdateEmployee)="updateEmployee($event)"></app-full-employees-list>
        </ng-container>
        <ng-template #emptyList>
            <ng-container *ngIf="alreadyLoaded; else loadingList">
                <app-empty-list (onAddEmployee)="onActionClicked()"></app-empty-list>
            </ng-container>
        </ng-template>
        <ng-template #loadingList>
            <p>{{'employees.fulllist.loading' | translate}}</p>
        </ng-template>
    </div>
</app-dashboard-layout>
